import * as React from 'react';
import './style.css';

import App from 'src/state/App';

const Row: React.SFC<{
  rank: number,
  name: string,
  rating: number,
  relRating: number,
  decoration?: string | null,
}> = (
  ({ rank, name, rating, relRating, decoration }) => {
    const width = (100 * relRating) + '%';

    return (
      <div className={`leaderboard-row${rank % 2 === 0 ? ' alt' : ''}`}>
        <div className="wrap">
          <div className="shading" style={{ width }}/>
          <div className="tint"/>
          <div className="label">{rank}. {name}</div>
          <div className="rating">{Math.round(App.scaleRating(rating))}</div>
          {!decoration ? [] : (
            <div className="rating-decoration">{decoration}</div>
          )}
          <span>&nbsp;</span>
        </div>
      </div>
    );
  }
);

export default Row;



// WEBPACK FOOTER //
// ./src/ui/Leaderboard/Row.tsx